import * as Mui from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

interface Props {
    open: boolean;
    onClose: () => void;
};
const FileImportError = (props: Props) => {
    return(
    <>
        <Mui.Dialog
            open={props.open} 
            onClose={props.onClose}
            fullWidth
            maxWidth="sm"
        >
            <Mui.Box style={{
                border:"2px solid gray", 
                borderStyle:"dashed",
            }}>
                <Mui.DialogActions 
                    sx={{display: "block", 
                        paddingLeft: "10px", 
                        paddingRight: "20px", 
                        paddingBottom: "50px"
                    }}
                > 
                    <Mui.Grid 
                        container 
                        spacing={2} 
                        textAlign={"center"} 
                        sx={{paddingTop: "25px", paddingBottom: "25px"}}
                    >
                        <Mui.Grid item xs={12} md={4}>
                            <InsertPhotoIcon sx={{ fontSize: "50px", color: "gray" }} />
                            <Mui.Typography variant="h5" color="gray">
                                Nome-File.Jpg
                            </Mui.Typography>
                        </Mui.Grid>
                        <Mui.Grid item xs={12} md={4}>
                            <InsertPhotoIcon sx={{ fontSize: "50px", color: "gray" }} />
                            <Mui.Typography variant="h5" color="gray">
                                Nome-File.Png
                            </Mui.Typography>
                        </Mui.Grid>
                        <Mui.Grid item xs={12} md={4}>
                            <PictureAsPdfIcon sx={{ fontSize: "50px", color: "gray" }} />
                            <Mui.Typography variant="h5" color="gray">
                                Nome-File.Pdf
                            </Mui.Typography>
                        </Mui.Grid>
                    </Mui.Grid>

                    <Mui.Card>
                        <Mui.CardContent>
                            <Mui.Grid container>
                                <Mui.Grid item>
                                    <WarningIcon sx={{ color: "red", fontSize: "20px" }} />
                                </Mui.Grid>
                                <Mui.Grid item>
                                    <Mui.Typography variant="h5" paddingLeft={"15px"}>
                                        File import error
                                    </Mui.Typography>
                                </Mui.Grid>
                            </Mui.Grid>
                        </Mui.CardContent>
                        <Mui.Divider />

                        <Mui.CardContent>
                            <Mui.Typography fontSize="15px">
                                The imported file is not the correct file type
                            </Mui.Typography>
                            <Mui.Typography paddingTop="15px" fontSize="15px">
                                To resolve the error, check  the file name and make sure the extension is .jpg .png or .pdf then re-import the file.
                            </Mui.Typography>
                        </Mui.CardContent>
                        <Mui.CardActions sx={{backgroundColor:"#F8F8F8"}}>
                            <Mui.Button 
                                type="submit" 
                                style={{padding: "25px", marginLeft: "auto"}} 
                                onClick={props.onClose}
                            >
                                <Mui.Typography color={'accent'} fontWeight={700}>
                                    {"Close"}
                                </Mui.Typography>
                            </Mui.Button>
                        </Mui.CardActions>
                    </Mui.Card>
                </Mui.DialogActions> 
            </Mui.Box>
        </Mui.Dialog>
    </>
    )
}
export default FileImportError;